import eSystemControllerTypes from '../eControllerTypes';

export default {
  EFCT_FORM: `${eSystemControllerTypes.ECT_FEEDBACK}__form`,
  EFCT_SUBMIT_SUCCESS: `${eSystemControllerTypes.ECT_FEEDBACK}__submit_success`,
}
